<div
  [ngClass]="{ 'horizontal-app-select': horizontalLabel }"
  class="app-select-container"
>
  <div class="app-select-label">
    <label>{{ label }}</label>
  </div>
  <ng-select
    class="app-select"
    [searchable]="searchable"
    [clearable]="clearable"
    [placeholder]="placeholder"
    [formControl]="appSelectFormControl"
  >
    <ng-option *ngFor="let option of appSelectOptions" [value]="option.value">
      {{ option.displayName }}
    </ng-option>
  </ng-select>
</div>
